module.exports = __webpack_public_path__ + "static/media/default_hero.89e0a703.png";